var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoitcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 429.09 193.63",
    style: {
      enableBackground: "new 0 0 429.09 193.63"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ITCARD_logo_claim"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.42,64.54h-21.76l-0.03,64.54h21.8c17.45,0,31.07-2.81,31.13-32.27 C364.48,67.35,350.87,64.54,333.42,64.54 M333.42,118.11h-8.89v-42.6h8.89c16.12,0,18.19,7.88,18.22,21.3 C351.61,110.23,349.54,118.11,333.42,118.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "85.52,75.55 101.29,75.55 101.29,129.08 114.2,129.08 114.2,75.55 132.92,75.55 132.92,64.54  85.52,64.54  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.51,64.54c-17.45,0-31.06,2.81-31.13,32.27c0.06,29.46,13.68,32.27,31.13,32.27h12.4l2.94-10.97h-15.34 c-16.12,0-18.19-7.88-18.22-21.3c0.03-13.42,2.1-21.3,18.22-21.3l13.11,0.03l-0.04-11.01H166.51z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.54,
    y: 64.54,
    className: "st0",
    width: 12.91,
    height: 64.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.46,87.78c0-21.13-13.68-23.24-31.13-23.24H253.4v64.54h12.91V75.51h5.02c16.12,0,18.22,5.78,18.22,12.26 c0,6.48-2.09,12.26-18.22,12.26h-0.57l16.67,29.05h15.03l-11.81-20.46C297.88,105.86,302.46,100.18,302.46,87.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.93,64.54h-23.7l-17.09,64.54h13.41l4.83-18.08h21.64l4.86,18.08h13.35L227.93,64.54z M208.3,100.04 l6.55-24.53h2.65l6.57,24.53H208.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoitcard);
export default __webpack_public_path__ + "static/media/logoitcard.a12803f3c4de1b140c111564ce82d536.svg";
export { ForwardRef as ReactComponent };